import { atom, useAtom, useSetAtom } from "jotai";

export const showOrders = atom(false);
const usePosShowOrders = () => {
  const atom = useAtom(showOrders);
  return atom;
};

export const useSetPosShowOrders = () => useSetAtom(showOrders);

export default usePosShowOrders;
